module.exports = __webpack_public_path__ + "img/ambulance-rwanda.8e90a038.jpg";